import React, { Fragment } from "react";
import {
  Navigate,
  Outlet,
  ScrollRestoration,
  createBrowserRouter,
} from "react-router-dom";
import Login from "./pages/auth/login";
import Signup from "./pages/auth/signup";
import Faqs from "./pages/faqs";
import About from "./pages/about";
import Templatelist from "./pages/templatelist";
import Selectplan from "./pages/selectplan";
import Forgotpassword from "./pages/auth/forgotpassword";
import ChangePassword from "./pages/changepassword";
import Home from "./pages/home";
import Categories from "./pages/categories";
import Templateview from "./pages/templateview";
import { loadFromLocalStorage } from "./utils/LocalStorageUtils";
import { setDefaultHeader } from "./utils/httpClient";
import AccountSetting from "./pages/accountSetting";
import Verification from "./pages/auth/verification";
import ErrorPage from "pages/ErrorPage";
import Orders from "pages/orders";
import DomainSelect from "pages/domain";
import Header from "./layout/header";
import Footer from "./layout/footer";
import CreatePassword from "pages/auth/createpassword";
import LoginMobile from "pages/auth/loginwithmobile";
import OurTemplate from "./pages/ourtemplate";
import ManageTemplates from "pages/managetemplates";
import Enquires from "pages/Enquires";
import MyAccount from "pages/myaccount";
import EditWebsite from "pages/editwebsite";
import Blogs from "pages/blog";
import RenewSubscription from "pages/renewsubscription";
import CheckoutPage from "pages/checkout";
import DomainSelection from "pages/selectdomain";
import OrderConfirmation from "pages/orderconfirmation";
import ContactUs from "pages/contactus";
import MyOrders from "pages/myorders";
import Templateform from "pages/templateform";
import SignupDetail from "pages/auth/signup/signupDetail";
import TermsAndConditions from "pages/faqs/termsnconditions";
import PrivacyPolicy from "pages/faqs/privacypolicies";
import WishlistPage from "pages/wishlist";
import OurMission from "pages/ourmission";
import HelpCenter from "pages/faqs/helpcenter";
import BlogDetailPage1 from "pages/blog/blogdetail1";
import Showcase from "pages/showcase";

const ProtectedRoute = ({ children }) => {
  const authData = loadFromLocalStorage("AUTH_DATA");
  if (!authData?.token) {
    return <Navigate to="/login" />;
  } else {
    setDefaultHeader("token", authData.token);
  }
  return children;
};
const RootRoute = ({ children }) => {
  return (
    <Fragment>
      <Outlet />
      <ScrollRestoration />
    </Fragment>
  );
};

const RootComponent = (component) => {
  const array = {
    home: <Home />,
    termsAndConditions: <TermsAndConditions />,
    faqs: <Faqs />,
    termsnconditions: <Faqs />,
    helpcenter: <HelpCenter />,
    privacyPolicy: <PrivacyPolicy />,
    about: <About />,
    ourmission: <OurMission />,
    ourTemplate: <OurTemplate />,
    templatelist: <Templatelist />,
    templateview: <Templateview />,
    manageTemplates: <ManageTemplates />,
    enquires: <Enquires />,
    myAccount: <MyAccount />,
    templateform: <Templateform />,
    blogs: <Blogs />,
    blogdetail: <BlogDetailPage1 />,
    showcase: <Showcase />,
    renewSubscription: <RenewSubscription />,
    checkoutPage: <CheckoutPage />,
    domainSelection: <DomainSelection />,
    orderConfirmation: <OrderConfirmation />,
    contactUs: <ContactUs />,
    categories: <Categories />,
    myorders: <MyOrders />,
    templateform: <Templateform />,
    wishlist: <WishlistPage />,
  };

  return (
    <Fragment>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Header />
        {array[`${component}`]}
        <div style={{ marginTop: "auto" }}>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        // element: <Home />,
        element: RootComponent("home"),
      },
      {
        path: "/faqs",
        // element: <Faqs />,
        element: RootComponent("termsAndConditions"),
      },
      {
        path: "/termsnconditions",
        // element: <TermsAndConditions />,
        element: RootComponent("termsAndConditions"),
      },
      {
        path: "/help-center",
        // element: <TermsAndConditions />,
        element: RootComponent("helpcenter"),
      },
      {
        path: "/privacypolicies",
        // element: <PrivacyPolicy />,
        element: RootComponent("privacyPolicy"),
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/loginmobile",
        element: <LoginMobile />,
      },

      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/signupDetail",
        element: <SignupDetail />,
      },
      {
        path: "/verification",
        element: <Verification />,
      },
      {
        path: "/about",
        // element: <About />,
        element: RootComponent("about"),
      },
      {
        path: "/our-mission",
        element: RootComponent("ourmission"),
      },
      {
        path: "/showcase",
        element: RootComponent("showcase"),
      },
      {
        path: "/ourtemplate",
        // element: <OurTemplate />,
        element: RootComponent("ourTemplate"),
      },
      {
        path: "/templatelist",
        // element: <Templatelist />,
        element: RootComponent("templatelist"),
      },
      {
        path: "/selectplan",
        // element: <Selectplan />,
        element: (
          <ProtectedRoute>
            <Header /> <Selectplan /> <Footer />
          </ProtectedRoute>
        ),
      },
      {
        path: "/templateview",
        // element: <Templateview />,
        element: RootComponent("templateview"),
      },
      {
        path: "/forgotpassword",
        element: <Forgotpassword />,
      },
      {
        path: "/createpassword",
        element: <CreatePassword />,
      },
      {
        path: "/editwebsite",
        // element: <Templateform />,
        element: RootComponent("templateform"),
      },
      {
        path: "/blogs",
        // element: <Blogs />,
        element: RootComponent("blogs"),
      },
      {
        path: "/blogs/:id",
        // element: <Blogs />,
        element: RootComponent("blogdetail"),
      },
      {
        path: "/billing",
        // element: <RenewSubscription />,
        element: RootComponent("renewSubscription"),
      },
      {
        path: "/checkout",
        // element: <CheckoutPage />,
        element: RootComponent("checkoutPage"),
      },
      {
        path: "/domainselect",
        // element: <DomainSelection />,
        element: RootComponent("domainSelection"),
      },
      {
        path: "/orderconfirmation",
        // element: <OrderConfirmation />,
        element: RootComponent("orderConfirmation"),
      },
      {
        path: "/contactus",
        // element: <ContactUs />,
        element: RootComponent("contactUs"),
      },
      {
        path: "/categories",
        // element: <Categories />,
        element: RootComponent("categories"),
        // element: <ProtectedRoute><Categories /></ProtectedRoute>,
      },
      {
        path: "/templateform",
        // element: <Templateform />,
        element: RootComponent("templateform"),
      },
      {
        path: "/myorders",
        // element: <MyOrders />,
        element: (
          <ProtectedRoute>
            <Header /> <MyOrders />
          </ProtectedRoute>
        ),
      },
      {
        path: "/myaccount",
        element: (
          <ProtectedRoute>
            <Header /> <MyAccount />
          </ProtectedRoute>
        ),
      },
      {
        path: "/enquires",
        element: (
          <ProtectedRoute>
            <Header /> <Enquires />
          </ProtectedRoute>
        ),
      },
      {
        path: "/managetemplate",
        element: (
          <ProtectedRoute>
            <Header /> <ManageTemplates />
          </ProtectedRoute>
        ),
      },
      {
        path: "/wishlist",
        element: (
          <ProtectedRoute>
            <Header /> <WishlistPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders",
        element: (
          <ProtectedRoute>
            <Header /> <Orders />
          </ProtectedRoute>
        ),
      },

      {
        path: "/domain",
        element: (
          <ProtectedRoute>
            <Header />
            <DomainSelect />
          </ProtectedRoute>
        ),
      },
      {
        path: "/accountsetting",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <AccountSetting />,
          },
          {
            path: "changepassword",
            element: <ChangePassword />,
          },
        ],
      },
    ],
  },
]);

export default router;
